export enum CallStateEnum {
  Init = 'INIT',
  Loading = 'LOADING',
  Loaded = 'LOADED',
  Error = 'ERROR'
}
